import 'css-chunk:src/app/containers/App/App.scss';export default {
  "App": "_App_gjckr_2",
  "spinner": "_spinner_gjckr_8"
};